import React, { useEffect, useState } from "react";
import axios from "axios";
import BlogPreview from "../components/BlogPreview";
import "./CommonBoard.css"; // 동일하게 공통 스타일 적용
import PageTitle from "../components/pageTitle.js";

export default function SNS() {
  const [posts, setPosts] = useState([]);
  const baseUrl = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    axios.get(`${baseUrl}/api/blog/latest`).then((res) => {
      setPosts(res.data);
    });
  }, []);

  return (
    <div className="board-sns-wrapper">
      <div className="board-sns-container">
      <div>
              <PageTitle title="SNS" />
            </div>
        <div className="board-sns-list grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
          {posts.slice(0, 9).map((post, idx) => (
            <BlogPreview key={idx} blogUrl={post.link} />
          ))}
        </div>
      </div>
    </div>
  );
}
